import * as React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import CircularProgressbar from "../common/CircularProgressbar";
import { getFirstName } from "../../helpers/formatting";
import * as d from "../../reducers/domainReducer";
import ProfileDashboardStep from "./ProfileDashboardStep";

class ProfileDashboard extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.ProfileDashboard.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {
        const { EnableProfileDashboard } = this.props;
        let currentUserName = this.props.currentUser &&  getFirstName(this.props.currentUser?.displayName);

        return (
            <div className="container-fluid body-content mybswh-profile-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">

                        <div className="row">
                            <div className="col-12">
                                <h1 className="page-heading">{currentUserName}'s Profile</h1>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-8 profile-detailtext">
                                We are always on new ways to improve your well being. Providing the following information allows MyBSWHealth account to work for you.
                            </div>

                            <div className="col-4 col-sm-3 offset-sm-1">
                                <div className="profile-progressbar">
                                    <CircularProgressbar overallScoreColor={"#00c4b3"} percentage={"20"} rotation={0.00} showPercentageSign />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12 profile-subtitle">
                                <h2>Complete your profile</h2>
                            </div>
                        </div>

                        <div className="row">
                            <ProfileDashboardStep
                                title="Contact info"
                                description="Stay in touch."
                                linkURL="/demographics"
                                linkText="ADD INFO"
                            />

                            <ProfileDashboardStep
                                title="Primary Care Physician"
                                description="Simplifying scheduling and messaging your PCP."
                                linkURL="/findcare"
                                linkText="MAKE AN APPOINTMENT"
                            />

                            <ProfileDashboardStep
                                title="Insurance"
                                description="Get more accurate pricing information."
                                linkURL="/insurance"
                                linkText="ADD PLAN"
                            />

                            <ProfileDashboardStep
                                title="Health Information/ Medical Records"
                                description="Keep your health record in one convenient spot."
                                linkURL="/linkedaccounts"
                                linkText="LINK HEALTH ACCOUNT"
                            />

                            <ProfileDashboardStep
                                title="Family Members"
                                description="Manage everyone through one account."
                                linkURL="/proxymanagement"
                                linkText="ADD FAMILY MEMBER"
                            />

                            <ProfileDashboardStep
                                title="Pharmacy Records"
                                description="Get new prescriptions and refills pronto."
                                linkURL="/linkedaccounts"
                                linkText="LINK PHARMACY ACCOUNT"
                            />

                            <div className="col-12">
                                <div className="profile-border" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

};

const mapStateToProps = (state) => {
    return {
        currentUser: d.hydrateProxyUser(state.domain.cu),
        EnableProfileDashboard: state.session.serverData && state.session.serverData.EnableProfileDashboard ? true : false,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileDashboard);
